module.exports = __webpack_public_path__ + "img/meat.09fc93ed.svg";